module.exports = __webpack_public_path__ + "27787c1bd096df331e77dee0c1d822ee.png";